// src/components/providers/ProvidersWrapper.tsx
import React from 'react';
import { AuthProvider } from '../../context/AuthContext';
import { NotificationProvider } from '../../context/NotificationContext';

interface ProvidersWrapperProps {
  children: React.ReactNode;
}

export const ProvidersWrapper: React.FC<ProvidersWrapperProps> = ({ children }) => {
  return (
    <AuthProvider>
      <NotificationProvider>
        {children}
      </NotificationProvider>
    </AuthProvider>
  );
};